export default class CriticalErrorService {
  public static goToError() {
    window.location.href = '/error';
  }
}
